export const FETCH_STOPPABLE_FILES_LOADING = 'FETCH_STOPPABLE_FILES_LOADING';
export const FETCH_STOPPABLE_FILES_COMPLETED = 'FETCH_STOPPABLE_FILES_COMPLETED';
export const FETCH_STOPPABLE_FILES_FAILED = 'FETCH_STOPPABLE_FILES_FAILED';
export const RECEIVE_STOPPABLE_FILES = 'RECEIVE_STOPPABLE_FILES';
export const STOP_FILE_REQUESTED = 'STOP_FILE_REQUESTED';
export const STOP_FILE_COMPLETED = 'STOP_FILE_COMPLETED';
export const STOP_FILE_FAILED = 'STOP_FILE_FAILED';
